import styled from "styled-components";

const FilterPriceRadio = styled.label`
`;

export default FilterPriceRadio;